/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserName } from './UserName';

export type LabOrder = {
    readonly id?: number;
    readonly case_id?: number;
    readonly slide_id?: number;
    readonly lab_panel_id?: number;
    type: LabOrder.type;
    /**
     * number representing the sequential order in which the slide's specimen was cut for this Order
     */
    sequence: number;
    /**
     * special instructions for the lab via the pathologist
     */
    note?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
    cancelled_at?: string | null;
    completed_at?: string | null;
    readonly transmitting_at?: string;
    readonly user?: UserName;
    readonly block_id?: number;
    readonly lab_stain_id?: number;
    inadequate: boolean;
}

export namespace LabOrder {

    export enum type {
        STAIN = 'stain',
        RECUT = 'recut',
        RESCAN = 'rescan',
        LEVEL = 'level',
        OTHER = 'other',
        CONTROL = 'control',
    }


}
